import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideSwaggerCore } from './core/swagger/swagger.provider';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { routes } from './app.routes';
import { BrowserModule } from '@angular/platform-browser';
import { providePrimengCore } from './core/common/primeng.provider';
import { provideAppStore } from './core/common/store.provider';
import { provideAppLegacyModules } from './core/common/legacy.modules.provider';
import { provideAppLegacyServices } from './core/common/legacy.services.providers';
import { CommonModule } from '@angular/common';
import { provideNativeDateAdapter } from '@angular/material/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideAnimationsAsync(),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules)
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    provideAnimationsAsync(),
    providePrimengCore(),
    ...provideSwaggerCore(),
    ...provideAppStore(),
    ...provideAppLegacyModules(),
    ...provideAppLegacyServices(),
  ]
};
